import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';

export interface ICin7Credentials {
    api_username: string,
    api_key: string,
}

class Cin7CredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: ICin7Credentials = {} as ICin7Credentials;

    constructor() {
        makeAutoObservable(this);
    }

    public get api_username() { return this._changes.api_username; }

    public set api_username(v: string) { this._changes.api_username = v; }

    public get api_key() { return this._changes.api_key; }

    public set api_key(v: string) { this._changes.api_key = v; }
    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as ICin7Credentials;
    }

    public getUpdatedModel(): ICin7Credentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default Cin7CredentialsStore;
